export enum RequisiteAddressType {
    PHONE = "phone",
    CARD = "card"
}